export default {
  name: 'Pagination',
  data() {
    return {
      currentPage: this.currentPageShow,
      pageSize: this.pageSizeShow
    };
  },
  props: {
    currentPageShow: {
      type: Number,
      default: 1
    },
    pageSizeShow: {
      type: Number,
      default: 5
    },
    total: {
      type: Number,
      default: 1
    },
    pageSizes: {
      type: Array,
      default() {
        return [5, 10, 20, 50];
      }
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    }
  },
  methods: {
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.$emit('pageChange', { pageNo: 1, pageSize: val });
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.$emit('pageChange', { pageNo: val, pageSize: this.pageSize });
    }
  }
};
